import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EMPTY, Subscription } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { tap } from 'rxjs/internal/operators/tap';
import { ImageCropperDialogComponent } from 'src/app/components/shared-components/image-cropper-dialog/image-cropper-dialog.component';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { DeviceInfo } from 'src/app/models/device-models/device-info-model/device-info.model';
import { ValidationImageService } from 'src/app/services/validation-images-service/validation-image.service';
import { DevicesDevicesService } from '../../../services/devices-services/devices-devices-services/devices-devices.service';
import { UserStorageService } from '../../../services/user-storage-service/user-storage.service';

@Component({
  selector: 'app-device-info-card',
  templateUrl: './device-info-card.component.html',
  styleUrls: ['./device-info-card.component.scss']
})
export class DeviceInfoCardComponent implements OnInit, OnDestroy {

  @ViewChild('uploadInput', { static: false }) uploadInput: ElementRef;
  @Input() deviceInfo: DeviceInfo;
  @Output() upadteDeviceEmitter = new EventEmitter<any>();
  updateDeviceStatusSubscription: Subscription;
  updateDeviceOwnImageSubscription: Subscription;
  showSpinner: boolean;

  constructor(private userStorageService: UserStorageService,
    private validationImageService: ValidationImageService,
    private devicesService: DevicesDevicesService,
    private snackbarService: SnackBarService,
    private spinnerService: SpinnerService,
    public dialog: MatDialog) { }

  ngOnInit() {
    this.showSpinner = false;
  }

  public toggleStatus() {
    this.updateDeviceStatusSubscription = this.devicesService.updateDeviceStatus(this.deviceInfo.InternalId).pipe(
      tap(o => this.upadteDeviceEmitter.emit()),
      tap(o => this.devicesService.refreshDevice()),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public uploadPhotoClicker() {
    this.uploadInput.nativeElement.value = null;
    this.uploadInput.nativeElement.click();
  }

  public uploadAsset(event) {
    const file = event.target.files[0];
    const img = new Image();
    this.validationImageService.toBase64(file).subscribe(
      (base64) => {
        const dialogRef = this.dialog.open(ImageCropperDialogComponent, {
          data: { image: base64, width: 250, height: 250 }
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.deviceInfo.DeviceImage = result;
            this.showSpinner = true;
            this.spinnerService.show('device-photo-editor-spinner');
            this.updateDeviceOwnImageSubscription = this.devicesService.updateDeviceOwnImage(this.deviceInfo.InternalId, result).pipe(
              tap(o => this.devicesService.refreshDevice()),
              tap(o => this.showSpinner = false),
              tap(o => this.spinnerService.hide('device-photo-editor-spinner')),
              catchError(error => {
                this.devicesService.refreshDevice();
                this.showSpinner = false;
                this.spinnerService.hide('device-photo-editor-spinner');
                this.snackbarService.open(error['error']['message'], 'error');
                return EMPTY;
              })
            ).subscribe();
          }
        });
      },
      (error) => {
        this.devicesService.refreshDevice();
        this.snackbarService.open(error, 'error');
      }
    );
  }

  public getPlatformIcon() {
    if (this.deviceInfo) {
      switch (true) {
        case /android/i.test(this.deviceInfo.Platform):
          return 'fab fa-android';
        case /ios/i.test(this.deviceInfo.Platform):
          return 'fab fa-apple';
        default:
          return 'far fa-question-circle';
      }
    } else {
      return '';
    }
  }

  public getStatus() {
    if (this.deviceInfo) {
      switch (this.deviceInfo.Status) {
        case 'ONLINE':
          return 'online';
        case 'WAITING_UPDATE':
          return 'waiting';
        case 'OFFLINE':
          return 'offline';
        default:
          return 'offline';
      }
    }
  }

  ngOnDestroy() {
    if (this.updateDeviceStatusSubscription) { this.updateDeviceStatusSubscription.unsubscribe(); }
    if (this.updateDeviceOwnImageSubscription) { this.updateDeviceOwnImageSubscription.unsubscribe(); }
  }
}
